<template>
  <div class="refill-container">
    <h2 class="my-3">
      {{ $t('billing.refill-balance.title') }}
      ({{ $t(`shared.currencies.${currentTenant.paymentCurrency}`) }})
    </h2>
    <div class="refill-box">
      <b-form-input
        v-model="amount"
        class="amount-input"
        :placeholder="$t('billing.refill-balance.enter-amount')"
        @keydown="onlyAcceptNumbers"
      ></b-form-input>

      <b-button
        variant="primary"
        size="sm"
        class="add-btn"
        @click="onAddAmount"
        :disabled="Number(amount) < minAmount || loading"
      >
        {{ $t('billing.refill-balance.add') }}
      </b-button>
    </div>

    <small class="text-muted mt-2 d-block">
      {{ $t('billing.refill-balance.min-amount-hint', { min: minAmount }) }} ({{
        $t(`shared.currencies.${currentTenant.paymentCurrency}`)
      }})
    </small>

    <div class="mt-4 text-center" v-if="loading">
      <b-spinner small></b-spinner>
    </div>

    <div class="stripeForm" v-if="paymentProvider === 'stripe'">
      <stripe-element-payment
        ref="paymentRef"
        :pk="pk"
        :elements-options="elementsOptions"
        :confirm-params="confirmParams"
        @element-ready="onLoading"
        @error="onError"
        :locale="locale"
      />
      <b-button
        variant="primary"
        size="sm"
        class="my-3"
        :disabled="loading"
        @click="pay"
      >
        {{ $t('billing.refill-balance.pay-now') }}
      </b-button>
    </div>

    <div class="iframe mt-4" v-if="paymentProvider === 'paytabs'">
      <iframe
        v-if="!!paymentReference"
        name="payTabs"
        :src="paymentReference"
        lang="ar"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { StripeElementPayment } from '@vue-stripe/vue-stripe'
import http from '../../axios'

import { mapGetters } from 'vuex'
import Vue from 'vue'
import { onlyAcceptNumbers } from '../../utils/utils'
import billingService from '../../services/billing.service'

export default {
  components: {
    StripeElementPayment
  },
  computed: {
    ...mapGetters(['providers', 'currentJera', 'currentTenant']),
    locale() {
      return Vue.i18n.locale()
    },
    minAmount() {
      const minAmounts = { sar: 100, usd: 25 }
      return minAmounts[this.currentTenant.paymentCurrency] || 5
    },
    amounts() {
      return [...this.providers[0].amountOptions, { label: 'Other', paid: 0 }]
    }
  },
  data() {
    return {
      pk: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      elementsOptions: {
        appearance: {} // appearance options
      },
      confirmParams: {
        return_url: `${window.location.origin}`
      },
      redirect: 'if_required',
      selectedAmount: null,
      amount: 0,
      loading: false,
      paymentProvider: null,
      paymentReference: null
    }
  },
  methods: {
    // utils
    onlyAcceptNumbers(event) {
      onlyAcceptNumbers(event)
    },
    pay() {
      this.$refs.paymentRef.submit()
    },
    async onAddAmount() {
      try {
        if (!/^[0-9]*$/.test(this.amount)) {
          this.toast(
            this.$t('billing.refill-balance.amount.validation.numeric'),
            { type: 'error' }
          )
          return
        }

        if (Number(this.amount) < this.minAmount) {
          this.toast(
            this.$t('billing.refill-balance.min-amount-hint', {
              min: this.minAmount
            }),
            { type: 'error' }
          )
          return
        }

        this.loading = true
        const res = await billingService.createPayment({
          amount: Number(this.amount)
        })
        this.paymentProvider = res.data.paymentProvider
        this.paymentReference = res.data.paymentReference
        this.elementsOptions.clientSecret = res.data.paymentReference
      } catch (error) {
        const errorMessage = error.response
          ? error.response.data.message
          : error.message
        this.toast(errorMessage, { type: 'error' })
      } finally {
        this.loading = false
      }
    },
    onError(error) {
      this.toast(error.message, {
        type: 'error'
      })
    },
    onLoading(something) {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.refill-container {
  max-width: 480px;
  margin: 0 auto;
}

.refill-box {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.amount-input {
  flex: 1;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  padding: 0.6rem 0.8rem;
  font-size: 1rem;
}

.add-btn {
  border-radius: 0.5rem;
  padding: 0.55rem 1rem;
  white-space: nowrap;
}

.iframe {
  width: 100%;
  height: 600px;
  border: none;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
